import React, { Component } from "react";
import Header from "../layout/Header";
import BannerSimple from "../layout/BannerSimple";
import Footer from "../layout/Footer";
import SEO from "../layout/SEO";
import ContactForm from "../layout/ContactForm";
import NewsletterSubscribe from "../layout/NewsletterSubscribe";

export default class Contact extends Component {
	componentDidMount() {
		window.resetScript();
	}

	render() {
		return (
			<>
				<SEO
					title="Contact"
					description="Contactez-moi pour discuter de vos projets, collaborations ou toute autre demande. Je serai ravi de vous répondre."
					keywords="contact, formulaire de contact, collaboration, projets"
				/>
				<Header active={"Contact"} modeDark={true} />

				<BannerSimple title="Contact" boxElement={[{ name: "Accueil", link: "/" }, { name: "Me Contacter", link: "/contact" }]} />

				<ContactForm />

				<NewsletterSubscribe variant="compact" />

				<Footer />
			</>
		);
	}
}